export default __webpack_public_path__ + "static/media/DP2 2D.bb8d78bb.jpg";